module.exports = __webpack_public_path__ + "static/media/optaplan-timeline.b201f809.mp4";